const defaultPath = "activitybooks";
const defaultPathName = defaultPath.charAt(0).toUpperCase() + defaultPath.slice(1);

export const activitybooksRouters = [
  {
    name: "ActivitybooksHome",
    path: `/${defaultPath}`,
    component: () => import(`../../views/${defaultPath}/Home.vue`),
  },
  {
    name: "ActivitybooksCreate",
    path: `/${defaultPath}/create`,
    component: () => import(`../../views/${defaultPath}/Create.vue`),
  },
  {
    name: "ActivitybooksUpdate",
    path: `/${defaultPath}/:id/edit`,
    component: () => import(`../../views/${defaultPath}/Update.vue`),
  },
  {
    name: "ActivitybooksDetail",
    path: `/${defaultPath}/:id`,
    component: () => import(`../../views/${defaultPath}/Detail.vue`),
  },
  {
    name: "ActivitybooksList",
    path: `/${defaultPath}/list`,
    component: () => import(`../../views/${defaultPath}/List.vue`),
  },
  {
    name: "ActivitybooksSearch",
    path: `/${defaultPath}/search`,
    component: () => import(`../../views/${defaultPath}/Search.vue`),
  },
  {
    name: "ActivitybooksPreview",
    path: `/${defaultPath}/:id/preview`,
    component: () => import(`../../views/${defaultPath}/Preview.vue`),
  },
];
